null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala-js/scala-js/v0.6.29/library/src/main/scala-old-collections/scala/scalajs/js/Any.scala